import { render, staticRenderFns } from "./Availability.vue?vue&type=template&id=c0bf2dde&scoped=true&"
import script from "./Availability.vue?vue&type=script&lang=js&"
export * from "./Availability.vue?vue&type=script&lang=js&"
import style0 from "./Availability.vue?vue&type=style&index=0&id=c0bf2dde&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0bf2dde",
  null
  
)

export default component.exports